import { useLingui } from '@lingui/react/macro';

import { MobileEntityFilter } from '@/components/SharedFilters/EntityFilter/MobileEntityFilter';
import IconPlace from '@/icons/Place.svg';

import { useFilters } from '../FiltersState';

export const FiltersOrigin = () => {
  const { t } = useLingui();

  const {
    origins: { origins, setOrigins },
  } = useFilters();

  return (
    <MobileEntityFilter
      filterId="origin"
      selectedEntities={origins}
      setSelectedEntities={setOrigins}
      traits={['store', 'workshop']}
      label={t({ id: 'shipments.filters.origin.label', message: 'Origin' })}
      searchPlaceholder={t({
        id: 'shipments.filters.origin.search.label',
        message: 'Search origins',
      })}
      icon={<IconPlace start />}
    />
  );
};
